var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 152,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 72,
    width: 64,
    y: 0,
    x: 0,
    id: "filter0_d_3067_33792"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "svg_6"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "svg_1",
    filter: "url(#filter0_d_3067_33792)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_2",
    fill: "#B2BFCC",
    d: "m91.90512,105.04828c19.498,-5.86296 33.73784,-24.36247 33.73784,-46.27656c0,-26.6279 -21.02479,-48.21405 -46.96002,-48.21405c-25.93524,0 -46.96002,21.58615 -46.96002,48.21405c0,21.91409 14.24004,40.4136 33.73784,46.27656c6.30654,2.059 10.40028,7.3917 11.93254,14.01072c0.14303,0.61831 0.67055,1.07206 1.28964,1.07206c0.61909,0 1.14661,-0.45375 1.28964,-1.07206c1.53227,-6.61902 5.62601,-11.95172 11.93254,-14.01072z",
    clipRule: "evenodd",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("circle", {
    stroke: "#3B424B",
    id: "svg_3",
    strokeWidth: 2,
    fill: "white",
    r: 7.82667,
    cy: 139.69773,
    cx: 78.68293
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#3B424B",
    id: "svg_4",
    strokeWidth: 0.5,
    fill: "#4E5864",
    d: "m92.8676,105.45859l0,0l-0.01096,0.00352c-7.02718,2.26915 -11.56214,8.14228 -13.25271,15.36532c-0.10781,0.45982 -0.49621,0.77112 -0.921,0.77112c-0.42479,0 -0.81339,-0.31131 -0.921,-0.77112c-1.69056,-7.22304 -6.22533,-13.09617 -13.25271,-15.36532l0,-0.0002l-0.01096,-0.00333c-20.91658,-6.22025 -36.19953,-25.85149 -36.19953,-49.11314c0,-28.26661 22.56488,-51.16862 50.38419,-51.16862c27.81931,0 50.38419,22.90201 50.38419,51.16862c0,23.26165 -15.28275,42.89289 -36.19953,49.11314z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_5",
    fill: "white",
    d: "m78.68293,37.95102c-10.80081,0 -19.56668,8.76587 -19.56668,19.56668c0,10.80081 8.76587,19.56668 19.56668,19.56668c10.80081,0 19.56668,-8.76587 19.56668,-19.56668c0,-10.80081 -8.76587,-19.56668 -19.56668,-19.56668zm-10.76167,30.32835l14.69457,-6.82877l6.82877,-14.69457l-14.69457,6.82877l-6.82877,14.69457zm12.91401,-10.76167c0,-1.19357 -0.95877,-2.15233 -2.15233,-2.15233c-1.19357,0 -2.15233,0.95877 -2.15233,2.15233c0,1.19357 0.95877,2.15233 2.15233,2.15233c1.19357,0 2.15233,-0.95877 2.15233,-2.15233z",
    clipRule: "evenodd",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActive);
export default __webpack_public_path__ + "static/media/43f5c4b2cf5126db535732458a819e99647707e2f0.svg";
export { ForwardRef as ReactComponent };